/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_TitleInputs */

const et_blog_title = /** @type {(inputs: Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogi - ScalingWebs`)
};

const en_blog_title = /** @type {(inputs: Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog - ScalingWebs`)
};

/**
* | output |
* | --- |
* | "Blog - ScalingWebs" |
*
* @param {Blog_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_title = /** @type {((inputs?: Blog_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_blog_title(inputs)
	return en_blog_title(inputs)
});